export enum DisputeDetailsMaxLengths {
  REQUEST_EXPLANATION = 3000,
  ISSUES_ACTIONS = 4000,
}
